export default __webpack_public_path__ + "static/media/projTrack3.e1a54e4b.png";